import { Box, Chip, Stack, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { UserRead } from "src/store/api/generatedApi";

interface AssignmentOverviewProps {
  users: UserRead[];
  assignmentStats: Map<string, number>;
  unassignedCount: number;
  getUserColor: (userId: string | null) => string;
}

export const AssignmentOverview = ({
  users,
  assignmentStats,
  unassignedCount,
  getUserColor,
}: AssignmentOverviewProps) => {
  const { t } = useTenantTranslation();

  return (
    <Stack spacing={2}>
      <Typography variant="h6">{t("assignmentOverview")}</Typography>
      <Stack spacing={1}>
        {users.map((user) => {
          const count = assignmentStats.get(user.uid) ?? 0;
          return (
            <Box
              key={user.uid}
              sx={{
                p: 1,
                borderRadius: 1,
                backgroundColor: "background.default",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    backgroundColor: getUserColor(user.uid),
                  }}
                />
                <Typography variant="body2">{user.name}</Typography>
              </Box>
              <Chip label={count} size="small" />
            </Box>
          );
        })}
        <Box
          sx={{
            p: 1,
            borderRadius: 1,
            backgroundColor: "background.default",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: "#e0e0e0",
              }}
            />
            <Typography variant="body2">{t("unassigned")}</Typography>
          </Box>
          <Chip label={unassignedCount} size="small" />
        </Box>
      </Stack>
    </Stack>
  );
};
